import { LocationAliasMapper } from "./location-alias.mapper";
import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";

export class LocationAlias extends CrudAbstractModel {
  constructor(
    public id: number,
    public name: string,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public setId(id: number): void {
    this.id = id;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }

  public getRequestParams() {
    return {
      name: this.getName(),
    };
  }

  public getClone(): LocationAlias {
    return LocationAliasMapper.map({
      id: this.id,
      name: this.name,
    });
  }

  public isValid(): boolean {
    return this.name && this.name !== "" ? true : false;
  }
}
